/* Says what is happening between a checkout click and the checkout itself. GoKwik's form
   arrives a second or two after the click, with the cart drawer already closed; when GoKwik
   is not available the theme waits three seconds and then goes to Shopify's checkout. Either
   way the page would otherwise show nothing. Vendor code is not touched: the cue is GoKwik's
   own "processing" class on its button, the same one hov-growth.js counts. */
(function () {
  'use strict';
  if (typeof MutationObserver !== 'function') return;
  // Never left up: after this the page is usable again whatever happened to the checkout.
  var LIMIT = 12000;
  var note = null, poll = null, limit = null;

  function formShown() {
    var frame = document.querySelector('.gokwik-modal iframe, iframe[src*="gokwik.co"]');
    return !!frame && frame.offsetWidth > 200 && frame.offsetHeight > 200;
  }
  function clear() {
    clearInterval(poll);
    clearTimeout(limit);
    if (note) note.remove();
    note = poll = limit = null;
  }
  function show() {
    if (note || formShown()) return;
    note = document.createElement('div');
    note.className = 'hov-opening';
    note.setAttribute('role', 'status');
    note.innerHTML = '<div class="hov-opening__card"><i aria-hidden="true"></i><p>Opening secure checkout</p><small>One moment</small></div>';
    document.body.appendChild(note);
    poll = setInterval(function () { if (formShown()) clear(); }, 150);
    limit = setTimeout(clear, LIMIT);
  }

  new MutationObserver(function (changes) {
    changes.forEach(function (change) {
      var node = change.target;
      if (!node.matches('.gokwik-marge.processing') || /(?:^|\s)processing(?:\s|$)/.test(change.oldValue || '')) return;
      show();
    });
  }).observe(document.body, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  // The Back button restores the page as it was left, note included.
  window.addEventListener('pageshow', function (event) { if (event.persisted) clear(); });
})();
